import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  copy: {
    id: 'copyPaste.alt',
    defaultMessage: 'Vágólapra másol',
  },
})
